// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5fe45bf9","266":"0ded5889","634":"f4364bcc"}[chunkId] + ".chunk.js";
};